/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorCheckItemDto } from '../../models/create-vendor-check-item-dto';
import { VendorCheckItemDto } from '../../models/vendor-check-item-dto';

export interface AsControllerCreateChecklistItem$Params {
  clientWorkspaceId: string;
  symptomId: string;
      body: CreateVendorCheckItemDto
}

export function asControllerCreateChecklistItem(http: HttpClient, rootUrl: string, params: AsControllerCreateChecklistItem$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorCheckItemDto>> {
  const rb = new RequestBuilder(rootUrl, asControllerCreateChecklistItem.PATH, 'post');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.path('symptomId', params.symptomId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorCheckItemDto>;
    })
  );
}

asControllerCreateChecklistItem.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}/check-items';
